import { __assign, __awaiter, __extends, __generator, __rest } from "tslib";
import dayjs from 'dayjs';
import { performance } from 'perf_hooks';
import SqliteDriver from '../sqlite';
import { SqljsConnection } from './sqljs-connection';
import { calculateDuration } from '../../utils';
var SqljsDriver = /** @class */ (function (_super) {
    __extends(SqljsDriver, _super);
    function SqljsDriver(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sqljs';
        return _this;
    }
    /**
     * @override
     */
    // @ts-ignore
    SqljsDriver.prototype.createPool = function (opts) {
        var database = opts.database, restOpts = __rest(opts, ["database"]);
        return new SqljsConnection(__assign(__assign({}, restOpts), { name: database }));
    };
    SqljsDriver.prototype.getConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pool.getConnection()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SqljsDriver.prototype.query = function (query, values, spell) {
        return __awaiter(this, void 0, void 0, function () {
            var connection, logger, logOpts, sql, start, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConnection()];
                    case 1:
                        connection = _a.sent();
                        // sql.js does not support Date as parameterized value
                        if (Array.isArray(values)) {
                            values = values.map(function (entry) {
                                if (entry instanceof Date) {
                                    return dayjs(entry).format('YYYY-MM-DD HH:mm:ss.SSS Z');
                                }
                                return entry;
                            });
                        }
                        logger = this.logger;
                        logOpts = __assign(__assign({}, spell), { query: query });
                        sql = logger.format(query, values, spell);
                        start = performance.now();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, connection.query(query, values, spell)];
                    case 3:
                        result = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        logger.logQueryError(err_1, sql, calculateDuration(start), logOpts);
                        throw err_1;
                    case 5:
                        logger.tryLogQuery(sql, calculateDuration(start), logOpts, result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return SqljsDriver;
}(SqliteDriver));
export default SqljsDriver;
//# sourceMappingURL=index.js.map